import { AlignLeft, AlignCenter, AlignRight } from "lucide-react";
import { SliderField } from "@/components/SliderField";
import { DEFAULT_TEXT_STYLE } from "@/lib/poster";

const ALIGNS = [
  { id: "left", icon: AlignLeft, label: "Gauche" },
  { id: "center", icon: AlignCenter, label: "Centre" },
  { id: "right", icon: AlignRight, label: "Droite" },
];
const signed = (v) => `${v > 0 ? "+" : ""}${v} %`;

export const TextStyleControls = ({ fieldKey, style, onChange }) => {
  const st = { ...DEFAULT_TEXT_STYLE, ...style };
  const set = (patch) => onChange({ ...st, ...patch });
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-4 rounded-xl bg-[#EADFD3]/70 p-4" data-testid={`text-style-${fieldKey}`}>
      <SliderField label="Taille du texte" value={st.size} min={30} max={250} onChange={(v) => set({ size: v })} testId={`text-size-${fieldKey}`} />
      <SliderField label="Espacement des lettres" value={st.spacing || 0} min={-5} max={60} format={(v) => `${v} %`} onChange={(v) => set({ spacing: v })} testId={`text-spacing-${fieldKey}`} resetTo={0} />
      <SliderField label="Position (haut / bas)" value={st.dy} min={-30} max={30} step={0.5} format={signed} onChange={(v) => set({ dy: v })} testId={`text-offset-${fieldKey}`} />
      <div className="flex items-center justify-between gap-3">
      <span className="text-xs text-[#6B5F53]">Alignement</span>
      <div className="flex rounded-full bg-white p-0.5">
        {ALIGNS.map((a) => (
          <button key={a.id} type="button" title={a.label} onClick={() => set({ align: a.id })} data-testid={`text-align-${fieldKey}-${a.id}`}
            className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-200 ${st.align === a.id ? "bg-[#3A322B] text-white" : "text-[#9A8C7D]"}`}>
            <a.icon size={14} />
          </button>
        ))}
      </div>
      </div>
    </div>
  );
};
